import { Box, Button, Grid2, Tooltip, Typography } from "@mui/material";
import { MainContent } from "IF/interfaceType";
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL, RESPONSE_CODE } from "Utils/apiUtil";
import { UserRole, useSessionStorage } from "IF/userSession";
import ConfirmationModal from "./ConfirmationModal";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import SignalCellularOffIcon from "@mui/icons-material/SignalCellularOff";

export const DashboardAreaStatus = ({ panel }: { panel: MainContent }) => {
  // ユーザ情報
  const { getUserData } = useSessionStorage();
  const userData = getUserData();
  const { id: userId, companyCode, userRole } = userData;

  // 確認モーダル
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null);
  const handleConfirmModalClose = () => setConfirmModalOpen(false);

  const handleConfirmModalOpen = (
    message: string,
    confirmAction: () => void
  ) => {
    setConfirmMessage(message);
    setOnConfirm(() => confirmAction);
    setConfirmModalOpen(true);
  };

  // 強制退出
  const handleForcedExit = async () => {
    try {
      const simId = panel.simId;
      // API呼び出し
      const response = await axios.post(`${API_BASE_URL}/Main/ForcedExit`, {
        schema: companyCode,
        userId: userId,
        simId: simId,
      });
      if (response.status === RESPONSE_CODE.SUCCESS) {
        alert("強制退出を実行しました。");
      }
    } catch (error: any) {
      if (error.status === RESPONSE_CODE.BAD_REQUEST) {
        alert(error.response.data);
        console.error("Status code:", error.response.status);
        console.error("Message:", error.response.data);
      } else {
        alert("強制退出の実行に失敗しました。");
        console.error("強制退出の実行に失敗しました。", error);
      }
    }
  };

  const createStatus = (panel: MainContent) => {
    if (panel.dangerNum > 0) {
      return (
        <Box
          sx={{
            color: "red",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
          }}
          className="status-box"
        >
          {/* 左側のテキスト部分 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            不安全警告
            <br />
            {panel.dashboardDataList.length}人滞在
            <br />
            {panel.dangerNum > 0 && <>{panel.dangerNum} 人未使用</>}
          </Box>

          {/* 右側：画像とボタンを配置する領域 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* 画像コンテナ: 高さの2/3 */}
            <Box
              sx={{
                flex: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src="/images/警告.png"
                alt="警告"
                style={{
                  width: "10vh",
                  height: "auto",
                }}
              />
            </Box>

            {/* ボタンコンテナ: 高さの1/3 */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
              }}
            >
              {userRole === UserRole.Admin || userRole === UserRole.YKC ? (
                <Button
                  variant="contained"
                  sx={{
                    width: "15vh",
                  }}
                  onClick={() =>
                    handleConfirmModalOpen("強制退出を実行します", () =>
                      handleForcedExit()
                    )
                  }
                >
                  強制退出
                </Button>
              ) : (
                <></>
              )}
            </Box>
          </Box>
        </Box>
      );
    } else if (panel.dashboardDataList.length > 0) {
      return (
        <Box
          sx={{
            color: "green",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
          }}
          className="status-box"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            正常利用中
            <br />
            {panel.dashboardDataList.length}人滞在
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-start", // 横方向は左寄せ
                alignItems: "flex-end", // 縦方向は下寄せ
              }}
            >
              {userRole === UserRole.Admin || userRole === UserRole.YKC ? (
                <Button
                  variant="contained"
                  sx={{
                    width: "15vh",
                  }}
                  onClick={() =>
                    handleConfirmModalOpen("強制退出を実行します", () =>
                      handleForcedExit()
                    )
                  }
                >
                  強制退出
                </Button>
              ) : (
                <></>
              )}
            </Box>
          </Box>
        </Box>
      );
    } else {
      return (
        <>
          <Box sx={{ color: "grey" }} className="status-box">
            滞在者無し
          </Box>
        </>
      );
    }
  };
  return (
    <Box>
      <ConfirmationModal
        open={confirmModalOpen}
        message={confirmMessage}
        handleClose={handleConfirmModalClose}
        onConfirm={onConfirm!}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "100%",
          p: 1,
          gap: 1,
        }}
      >
        <>
          <Grid2
            container
            direction="row"
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <Tooltip
              title={
                <span>
                  シリアルNo：{panel.serialNo}
                  <br />
                  エリア名：{panel.name}
                </span>
              }
              arrow
              placement="top"
            >
              <Box>
                <Grid2
                  container
                  style={{
                    textAlign: "left",
                  }}
                >
                  <Typography
                    fontWeight="fontWeightBold"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    シリアルNo：{panel.serialNo}
                  </Typography>
                </Grid2>
                <Grid2>
                  <Typography
                    fontWeight="fontWeightBold"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    エリア名：{panel.name}
                  </Typography>
                </Grid2>
              </Box>
            </Tooltip>
          </Grid2>
          <Grid2
            container
            direction="row"
            sx={{ display: { xs: "block", sm: "block", md: "none" } }}
          >
            <Grid2
              container
              style={{
                textAlign: "left",
              }}
            >
              <Typography
                fontWeight="fontWeightBold"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                No.{panel.serialNo}
              </Typography>
            </Grid2>
            <Grid2>
              <Typography
                fontWeight="fontWeightBold"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {panel.name}
              </Typography>
            </Grid2>
          </Grid2>
        </>
        <Grid2
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: panel.aliveFlg
              ? "linear-gradient(45deg, #4caf50, #2e7d32)"
              : "linear-gradient(45deg, #9e9e9e, #616161)",
            borderRadius: 2,
            minWidth: "80px",
            maxHeight: "35px",
            padding: "6px 12px",
            boxShadow: 3,
          }}
        >
          {panel.aliveFlg ? (
            <SignalCellularAltIcon sx={{ color: "white", mr: 0.5 }} />
          ) : (
            <SignalCellularOffIcon sx={{ color: "white", mr: 0.5 }} />
          )}
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            noWrap
            color="white"
          >
            {panel.aliveFlg ? "通信中" : "通信不可"}
          </Typography>
        </Grid2>
      </Box>
      <Box fontWeight="fontWeightBold">{createStatus(panel)}</Box>
    </Box>
  );
};

export default DashboardAreaStatus;
